// GO4S DS — téléchargement en POST précédé de la modale de confirmation.
//
// Pourquoi ce contrôleur plutôt qu'un simple lien data-turbo-method + data-turbo-confirm :
// Turbo transforme ce lien en formulaire et intercepte la réponse via fetch. Il sait
// traiter du HTML ou du turbo-stream, pas un corps binaire : un send_data de PDF
// ne déclenche alors aucun téléchargement et le clic reste sans effet visible.
//
// Et l'échappatoire habituelle (data: { turbo: false }) ne convient pas ici : sans
// rails-ujs dans le projet, data-turbo-confirm n'est plus lu par personne et la
// confirmation disparaît en silence — or l'action réinitialise le mot de passe de
// l'élève, l'avertissement n'est pas décoratif.
//
// On garde donc les deux : la modale du design system, puis une vraie soumission
// de formulaire (navigation native, hors Turbo) que le navigateur transforme en
// téléchargement.
//
// Usage :
//   <a href="…" data-controller="confirmed-download"
//      data-action="confirmed-download#download"
//      data-confirmed-download-message-value="Continuer ?">
import { Controller } from "@hotwired/stimulus";
import { dsConfirm } from "../../utils/ds_confirm.js";

export default class extends Controller {
  static values = {
    message: String,
    method: { type: String, default: "post" },
  };

  async download(event) {
    event.preventDefault();
    event.stopPropagation();

    const url = this.element.getAttribute("href") || this.element.dataset.url;
    if (!url) return;

    if (this.messageValue) {
      const confirmed = await dsConfirm(this.messageValue);
      if (!confirmed) return;
    }

    this.submit(url);
  }

  // Formulaire jetable soumis en navigation classique : le navigateur reçoit
  // Content-Disposition: attachment et enregistre le fichier sans quitter la page.
  submit(url) {
    const form = document.createElement("form");
    form.method = this.methodValue;
    form.action = url;
    form.style.display = "none";

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    if (token) form.appendChild(this.hiddenField("authenticity_token", token));

    document.body.appendChild(form);
    form.submit();
    // Retirer le formulaire dans le même tick peut annuler l'envoi selon le
    // navigateur : on attend que la navigation soit engagée.
    setTimeout(() => form.remove(), 0);
  }

  hiddenField(name, value) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }
}
